module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "project-wrapper"
  }, [_c('article', {
    staticClass: "project"
  }, [_c('h1', {
    staticClass: "project__title"
  }, [_vm._v(_vm._s(_vm.project.title.rendered))]), _vm._v(" "), _c('div', {
    staticClass: "project-header"
  }, [_c('div', {
    staticClass: "project-header__informations"
  }, [_c('h2', {
    staticClass: "project-header__title"
  }, [_vm._v("Infos")]), _vm._v(" "), _c('ul', {
    staticClass: "project-header__list no-style"
  }, _vm._l((_vm.project.CFS.informations), function(information, key) {
    return _c('li', {
      key: key,
      staticClass: "project-header__item"
    }, [_vm._v("\n            " + _vm._s(information.information) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('cms-content', {
    staticClass: "project-header__description",
    domProps: {
      "innerHTML": _vm._s(_vm.project.content.rendered)
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "project__video-wrapper"
  }, [_c('div', {
    staticClass: "project__video-inner"
  }, [_c('iframe', {
    staticClass: "project__video",
    attrs: {
      "src": _vm.project.CFS.videoLink,
      "frameborder": "0",
      "webkitallowfullscreen": "",
      "mozallowfullscreen": "",
      "allowfullscreen": ""
    }
  })])]), _vm._v(" "), _vm._l((_vm.project.CFS.makingOf), function(makingOf, key) {
    return _c('div', {
      key: key,
      staticClass: "project-picture js-observer",
      class: {
        'project-picture--left': key % 2 === 1
      }
    }, [_c('div', {
      staticClass: "project-picture__wrapper"
    }, [_c('img', {
      staticClass: "project-picture__picture",
      attrs: {
        "src": makingOf.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "project-picture__mask"
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "project-navigation",
    class: {
      'has-only-previous': !_vm.nextProject,
      'has-only-next': !_vm.previousProject,
    }
  }, [(_vm.previousProject) ? _c('div', {
    staticClass: "project-navigation__item"
  }, [_c('p', {
    staticClass: "project-navigation__label"
  }, [_vm._v("Précédent")]), _vm._v(" "), _c('router-link', {
    staticClass: "project-navigation__title",
    attrs: {
      "to": {
        name: 'Project',
        params: {
          slug: _vm.previousProject.slug
        }
      },
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v(_vm._s(_vm.previousProject.title.rendered))])])], 1) : _vm._e(), _vm._v(" "), (_vm.nextProject) ? _c('div', {
    staticClass: "project-navigation__item"
  }, [_c('p', {
    staticClass: "project-navigation__label"
  }, [_vm._v("Suivant")]), _vm._v(" "), _c('router-link', {
    staticClass: "project-navigation__title",
    attrs: {
      "to": {
        name: 'Project',
        params: {
          slug: _vm.nextProject.slug
        }
      },
      "active-class": ""
    }
  }, [_c('span', {
    staticClass: "inner"
  }, [_vm._v(_vm._s(_vm.nextProject.title.rendered))])])], 1) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "project__background"
  }), _vm._v(" "), _c('div', {
    staticClass: "projects__transition js-project-transition"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-531e6380","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProjectView.vue
// module id = 174
// module chunks = 1